define(function(require, exports, module) {
    var Config = require('../../Config/Config');
    var ticker = require('../../unit/ticker/ticker');
    var timeModel = {
        ajaxGetTime: function(data, success, error) {
            $.ajax({
                url: Config.serviceInterface.getTime,
                data: {},
                method: 'get',
                dataType: 'jsonp',
                success: function(data) {
                    if ($.isFunction(success)) {
                        success(data);
                    }
                }
            });
        },
        secondcount: function(options) {
            //默认参数
            var defaults = {
                timer: 1000,
                step: 1
            };
            var settings = $.extend(defaults, options || {});
            var step = settings.step || 1;
            var timer = settings.timer || 1000;
            var that = this;
            that.ajaxGetTime(null, function(data) {
                var timeNow = (new Date(data.timeNow));
                $('.cdtime').each(function() {
                    var self = $(this);
                    var endTime = self.attr('endTime');
                    var duringSecond = (endTime - timeNow.getTime()) / 1000;
                    self.attr('secondcount', parseInt(duringSecond));
                });
                //

                $('.payTime em').each(function() {
                    var self = $(this);
                    var orderTime = self.attr('order_time');
                    var duringSecond = (30*60*1000 - (timeNow.getTime() - orderTime)) / 1000;
                    self.attr('secondcount', parseInt(duringSecond));
                });
                ticker.init({
                    "step": step,
                    "timer": timer
                });
            });
        },

        calculateSecondCount: function(options) {
            //默认参数
            var defaults = {
                timer: 1000,
                step: 1
            };
            var settings = $.extend(defaults, options || {});

            //timer: 设置倒计时定时器时间，默认1000ms
            var step = settings.step || 1;
            var timer = settings.timer || 1000;
            var that = this;
            that.ajaxGetTime(null, function(data) {
                var timeNow = (new Date(data.timeNow));
                $('.cdtime').each(function() {
                    var self = $(this);
                    var endTime = self.attr('endTime');
                    var duringSecond = (endTime - timeNow.getTime()) / 1000;
                    self.attr('secondcount', parseInt(duringSecond));

                });
                ticker.init({
                    "step": step,
                    "timer": timer
                });
            });
        },

        //定金支付倒计时
        presaleSecondCount: function(options){
            //默认参数
            var defaults = {
                timer: 1000,
                step: 1
            };
            var settings = $.extend(defaults, options || {});

            //timer: 设置倒计时定时器时间，默认1000ms
            var step = settings.step || 1;
            var timer = settings.timer || 1000;
            var that = this;
            that.ajaxGetTime(null, function(data) {
                var timeNow = (new Date(data.timeNow));
                $('.payTime em').each(function() {
                    var self = $(this);
                    var orderTime = self.attr('order_time');
                    var endTime = self.attr('presaleendtime');
                    var payTime = 30*60*1000;
                    //var duringSecond;
                    // if(endTime > timeNow.getTime()){
                    //     if(endTime <= (parseInt(orderTime) + parseInt(payTime))){
                    //         duringSecond = (endTime - timeNow.getTime()) / 1000;
                    //     }else{
                    //         duringSecond = (30*60*1000 - (timeNow.getTime() - orderTime)) / 1000;
                    //     }
                    // }else{
                    //     return
                    // }
                    var duringSecond = (30*60*1000 - (timeNow.getTime() - orderTime)) / 1000;
                    self.attr('secondcount', parseInt(duringSecond));

                });
                ticker.init({
                    "step": step,
                    "timer": timer
                });
            });
        },

        //尾款支付倒计时
        presaleSecondCountLast: function(options){
            //默认参数
            var defaults = {
                timer: 1000,
                step: 1
            };
            var settings = $.extend(defaults, options || {});

            //timer: 设置倒计时定时器时间，默认1000ms
            var step = settings.step || 1;
            var timer = settings.timer || 1000;
            var that = this;
            that.ajaxGetTime(null, function(data) {
                var timeNow = (new Date(data.timeNow));
                $('.goodpay-step-two-btn .hideTime').each(function() {
                    var self = $(this);
                    var orderEndTime = self.attr('order_end_time');
                    var duringSecond = (orderEndTime - timeNow.getTime()) / 1000;
                    self.attr('secondcount', parseInt(duringSecond));
                });
                ticker.init({
                    "step": step,
                    "timer": timer
                });
            });
            ticker.init({
                "step": step,
                "timer": timer
            });
        },
        
        //订单详情页付定金/全款倒计时
        presaleConSecondCount: function(options){
            //默认参数
            var defaults = {
                timer: 1000,
                step: 1
            };
            var settings = $.extend(defaults, options || {});

            //timer: 设置倒计时定时器时间，默认1000ms
            var step = settings.step || 1;
            var timer = settings.timer || 1000;
            var that = this;
            that.ajaxGetTime(null, function(data) {
                var timeNow = (new Date(data.timeNow));
                $('.cdtime').each(function() {
                    var self = $(this);
                    var orderTime = self.attr('endtime');
                    var duringSecond = (30*60*1000 - (timeNow.getTime() - orderTime)) / 1000;
                    self.attr('secondcount', parseInt(duringSecond));

                });
                ticker.init({
                    "step": step,
                    "timer": timer
                });
            });
        },

        //订单详情页付尾款倒计时
        presaleConSecondCountDj: function(options){
            //默认参数
            var defaults = {
                timer: 1000,
                step: 1
            };
            var settings = $.extend(defaults, options || {});

            //timer: 设置倒计时定时器时间，默认1000ms
            var step = settings.step || 1;
            var timer = settings.timer || 1000;
            var that = this;
            that.ajaxGetTime(null, function(data) {
                var timeNow = (new Date(data.timeNow));
                $('.cdtime').each(function() {
                    var self = $(this);
                    var orderTime = self.attr('endtime');
                    var duringSecond = (orderTime - timeNow.getTime()) / 1000;
                    self.attr('secondcount', parseInt(duringSecond));

                });
                ticker.init({
                    "step": step,
                    "timer": timer
                });
            });
        },

    };
    module.exports = timeModel;
});



// WEBPACK FOOTER //
// ./src/js/model/timeModel/timeModel.js